import assetPath from '/app/packages/lebenslauf/articles/src/assets/der-ultimative-guide-zur-kurzbewerbung-was-wie-und-warum.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')